// Central content + contact configuration for the Windonline landing page.
// Easily update contacts / logo here.

export const CONTACT = {
  brand: "windonline",
  tagline: "Telefonia & Servizi · Moncalieri e Torino",
  phonePrimary: { label: "011 640 7287", tel: "0116407287" },
  phoneMobile: { label: "375 691 7630", tel: "+393756917630" },
  whatsapp: "393756917630",
  whatsappText: "Ciao windonline! Vorrei una consulenza gratuita.",
  email: "f.wmoncalieri@gmail.com",
  address: "Via Del Ballo 1, Moncalieri (TO)",
  mapsQuery: "Via Del Ballo 1, Moncalieri, TO",
  hours: [
    { day: "Lunedì – Venerdì", time: "10:00 – 12:30  ·  15:30 – 19:30" },
    { day: "Sabato", time: "10:00 – 13:00" },
    { day: "Domenica", time: "Chiuso", closed: true },
  ],
  social: {
    instagram: "https://www.instagram.com/windonline_sas",
    tiktok: "https://www.tiktok.com/@windonlinemoncalieri",
  },
};

export const waLink = () =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(CONTACT.whatsappText)}`;

// All physical stores. Moncalieri is the primary (used by hero/footer/floating CTA).
export const STORES = [
  {
    id: "moncalieri",
    name: "Windonline · Moncalieri",
    person: "Alessandro",
    address: "Via Del Ballo 1, Moncalieri (TO)",
    mapsQuery: "Via Del Ballo 1, Moncalieri, TO",
    phone: { label: "011 640 7287", tel: "0116407287" },
    mobile: { label: "375 691 7630", tel: "+393756917630" },
    whatsapp: "393756917630",
    email: "f.wmoncalieri@gmail.com",
    hours: [
      { day: "Lunedì – Venerdì", time: "9:30 – 12:30  ·  15:30 – 19:30" },
      { day: "Sabato", time: "9:30 – 13:00" },
      { day: "Domenica", time: "Chiuso", closed: true },
    ],
  },
  {
    id: "corso-orbassano",
    name: "Windonline · Torino Corso Orbassano",
    person: "Tamara",
    address: "Corso Orbassano 214, Torino",
    mapsQuery: "Corso Orbassano 214, Torino",
    phone: { label: "011 329 4839", tel: "0113294839" },
    mobile: { label: "389 448 3489", tel: "+393894483489" },
    whatsapp: "393894483489",
    email: "fastwebcorsoorbassano@gmail.com",
    hours: [
      { day: "Lunedì – Sabato", time: "9:30 – 12:30  ·  15:30 – 19:30" },
      { day: "Domenica", time: "Chiuso", closed: true },
    ],
  },
  {
    id: "pietro-cossa",
    name: "Windonline · Torino Via Pietro Cossa",
    person: "Simone",
    address: "Via Pietro Cossa 13/c, Torino",
    mapsQuery: "Via Pietro Cossa 13/c, Torino",
    mobile: { label: "328 077 7757", tel: "+393280777757" },
    whatsapp: "393280777757",
    email: "multiservicossa@gmail.com",
  },
];

export const waStore = (store) =>
  `https://wa.me/${store.whatsapp || CONTACT.whatsapp}?text=${encodeURIComponent(
    `Ciao ${store.person}! Vorrei una consulenza gratuita.`
  )}`;

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_mobile-solutions-pro-1/artifacts/behx7yyl_492F11CC-2883-48DC-AD1B-DDCD406C7E6C.png",
  fiber: "https://static.prod-images.emergentagent.com/jobs/a171a1e6-4f23-40aa-8ca0-95d0af87ab9c/images/1c17faab7ebff77e56800f6cb8d68a32d5ff3fb153ca1c61b965744ac6dbe151.png",
  energy: "https://static.prod-images.emergentagent.com/jobs/a171a1e6-4f23-40aa-8ca0-95d0af87ab9c/images/8ab185465c8d28ced1c2f8c4f6f43e256966908b712f95f5e399909aec8f7d5f.png",
  ctaTexture: "https://static.prod-images.emergentagent.com/jobs/a171a1e6-4f23-40aa-8ca0-95d0af87ab9c/images/43c16b25892a81e33d403e38000798e384a95d0aeea47b596c907a3620a7f2dd.png",
};
